angular.module('unica_workshop.workshop_controllers')

.controller('WorkshopCreateController', function(
	$rootScope, $scope, $state, $stateParams,
	WorkshopCreateService
) {

	$rootScope.getEvent( $stateParams.event_id );

	$rootScope.getEventStages( $stateParams.event_id );

	$rootScope.getRelatorList();

	$rootScope.getTrackList( $stateParams.event_id );

	$rootScope.workshopData = {
		event_id: $stateParams.event_id,
		filename: ''
	};

	$scope.uploader.onCompleteAll = function() {
		$scope.hideLoader();
		$scope.showSuccessMsg('Workshop aggiunto con successo!', '');
		$state.go('app.workshop.list', { event_id: $stateParams.event_id });
	};

	$scope.saveWorkshop = function()
	{
		$scope.showLoader();

		var workshopData = angular.copy($rootScope.workshopData);

		WorkshopCreateService
			.create( workshopData )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {

					if ( $scope.uploader.queue.length > 0 ) {

						$scope.uploader.queue[0].formData.push({ 'id' : data.id });
						$scope.uploader.formData.push({ 'id' : data.id });

						$scope.showLoader();
						$scope.uploader.uploadAll();
					} else {
						$scope.showSuccessMsg('Workshop aggiunto con successo!', '');
						$state.go('app.workshop.list', { event_id: $stateParams.event_id });
					}
				}
			});

	};

})

;